import { URL_PARAM_KEY } from 'globalConst/const';

const getSearchParams = (search: string): { [key: string]: string } => {
  const urlParams = new URLSearchParams(search);
  const searchValue = urlParams.getAll(URL_PARAM_KEY.SEARCH)[0];
  return { search: searchValue };
};

export default getSearchParams;
